<div class="loader">
    <div class="plotlybars-wrapper">
        <div class="plotlybars">
            <div class="plotlybars-bar b1"></div>
            <div class="plotlybars-bar b2"></div>
            <div class="plotlybars-bar b3"></div>
            <div class="plotlybars-bar b4"></div>
            <div class="plotlybars-bar b5"></div>
            <div class="plotlybars-bar b6"></div>
            <div class="plotlybars-bar b7"></div>
        </div>
        <div class="plotlybars-text">
            Loading
        </div>
    </div>
</div>